import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { FaPowerOff, FaUserAlt } from 'react-icons/fa';
import { AuthRole } from '../../services/AuthRole';
import { Api } from '../../services/api';
import axios from 'axios';
import ThemeMenu from '../thememenu/ThemeMenu';
import { MdHelpCenter } from 'react-icons/md';
import { useMsal } from "@azure/msal-react"; // Import MSAL



const pageNames = {

  "/": "Dashboard",

  "/business-core": "BUSINESS CORE",
  "/accountability-chart": "Accountability Chart",
  "/esr-dashboard": "Esr Dashboard",

  "/lead-tracker-dashboard": "Lead Tracker Dashboard",
  "/marketing": "Marketing & Sales Data",
  "/actives": "Actives",
  "/leads": "Leads",
  "/hold": "Hold",
  "/leads/2027": "Leads-2027",
  "/leads/2026": "Leads-2026",
  "/leads/2025": "Leads-2025",
  "/leads/2024": "Leads-2024",
  "/leads/2023": "Leads-2023",
  "/leads/2022": "Leads-2022",
  "/leads/2021": "Leads-2021",


  "/dashboard": "Production Schedule",
  "/production-schedule": "Production Schedule",
  "/pre-con-creep": "Pre Con Creep",
  "/construction-creep": "Construction Creep",
  "/overall-creep": "Over All Creep",

  "/project": "Project",

  "/workload": "Workload",

  "/cashflow": "Revenue Projections",
  "/summary": "financial Summary",

  "/projection": "Income Statement",
  "/budget": "Overhead Budget",

  "/actuals": "P&L By Job",

  "/billable": "Billable vs Unbillable",
  "/billable-year": "Billable Year",
  "/billable-Dashboard": "Pay periods",

  "/config": "Config",
  "/log": "Log-History",
  "/billable-config": "Billable Config",
  "/projecttype": "Project Type",
  "/projectmanager": "Project Manager",
  "/usermodule": "User Role",
  "/users": "Manage User",



  "/estimating-dashboard": "Estimating Dashboard",
  "/add-estimating": "Add Estimating",
  "/estimating-PerformancePoints": "Estimating PerformancePoints",
  "/estimating-Overall-JobPerformance": "Overall Job Performance",

  "/performance-huddle-dashboard": "Performance Huddle History",
  "/performance-huddle": "Performance Huddle",
  "/archive-history": "History",
  "/client-update-history": "Client Update Timestamp",



  "/playbooks": "Playbooks",
  "/pm-template": "PM Template",
  "/add-pm-template": "PM Template Add",
  "/edit-pm-template": "PM Template Edit",
  "/pm-performancePoints": "PM Pformance Points",
  "/pm-OverallJobPerformance": "PM Overall Job Performance",



  "/interior-design-dashboard": "Interior Design Dashboard",
  "/add-interior-design-template": "Interior Design Add",
  "/edit-interior-design-template": "Interior Design Edit",
  "/interior-design-performance-points": "Interior Design Performance Points",
  "/interior-design-overallJob-performance": "Interior Design Overall Job Performance",

  "/development-manager-dashboard": "Development Manager Dashboard",
  "/development-manager-template": "Development Manager Add",
  "/edit-development-manager-template": "Development Manager Edit",
  "/development-Performance-Points": "Development Manager Performance Points",
  "/development-OverallJob-Performance": "Development Manager Overall Job Performance",




  "/quarterly-huddle-conversation": "Quarterly Huddle Conversation",
  "/quarterly-huddle-conversation-history": "Quarterly Huddle Conversation History",
  "/team-score": "Team Score",

  "/performance-review" :"Performance Review",
  "/performance-review-history":"Performance Review History",

  "/vp-sales-and-marketing": "SALES  - PERFORMANCE HUDDLE",
  "/vp-sales-and-marketing-dashboard": "SALES  - PERFORMANCE HUDDLE History",
  // "/financial-controller": "ACCOUNTING ADMINISTRATOR PLAYBOOK",
  "/financial-controller": "FINANCIAL CONTROLLER PLAYBOOK",
  // "/financial-controller-dashboard": "ACCOUNTING ADMINISTRATOR PLAYBOOK History",
  "/financial-controller-dashboard": "FINANCIAL CONTROLLER PLAYBOOK HISTORY",

  "/accounting-dashboard": "ACCOUNTING History",
  "/accounting": "ACCOUNTING",


  "/cost-per-sf": "Cost Per SF",
  "/labour-framing-calculator": "Labour Framing Calculator",

  "/help": "Help",
  "/lead-source-config": "Lead Source Config",


};


const Navbar = () => {
  const { instance, accounts } = useMsal(); // Get instance
  const [userName, setUserName] = useState('');
  const [role_name, setRole_name] = useState('');
  const [imageSet, setImageSet] = useState(null);
  const [graphPhoto, setGraphPhoto] = useState(null);
  const [organizationName, setOrganizationName] = useState('Lida Construction');

  useEffect(() => {
    setOrganizationName(localStorage.getItem('organizationName'))
    getUser();
  }, []);

  useEffect(() => {
      // Only fetch if backend image is missing and user is logged in via Microsoft
      if (!imageSet && accounts.length > 0) {
          const request = {
              scopes: ["User.Read"],
              account: accounts[0]
          };

          instance.acquireTokenSilent(request).then((response) => {
              fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
                  headers: { Authorization: `Bearer ${response.accessToken}` }
              })
              .then(res => {
                  if (res.ok) return res.blob();
                  throw new Error("No photo found");
              })
              .then(blob => {
                  const url = URL.createObjectURL(blob);
                  setGraphPhoto(url);
              })
              .catch(err => {
                  // console.log("Microsoft Graph photo not found or error fetching.", err);
              });
          }).catch((e) => {
              // console.log("Silent token acquisition failed for photo", e);
          });
      }
  }, [imageSet, accounts, instance]);

  const getUser = async () => {
    const token = localStorage.getItem('authToken');

    const headers = {
      'Authorization': token ? `Bearer ${token}` : '', // Include token if available
    };

    try {
      const response = await axios.get(Api.API_BASE_URL + 'get-profile', { headers });
      const data = response.data.result;

      setUserName(data.first_name + ' ' + data.last_name);
      
      if(data.role_id && data.role_id.name) {
        localStorage.setItem('role_name', data.role_id.name);
      }
      
      setRole_name(data.role_id.name || localStorage.getItem('role_name')); // Set role_name from response or fallback to local storage
      setImageSet(data.image);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    } finally {
    }
  };

  const getProfileImage = () => {
    if (imageSet) {
        // If image is a full URL or blob, use it
        if (imageSet.startsWith('http') || imageSet.startsWith('blob:')) {
            return imageSet;
        }
        // Otherwise assume relative path and prepend API base
        return Api.IMAGE_BASE_URL + imageSet;
    }
    if (graphPhoto) return graphPhoto;
    return "https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI=";
  };

  const location = useLocation();
  const currentPagePath = location.pathname;

  const currentPageName = pageNames[currentPagePath] || "";
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = async () => {

    const token = localStorage.getItem('authToken');
    const authProvider = localStorage.getItem('authProvider');
    if (authProvider === 'microsoft') {
      sessionStorage.setItem('disableMicrosoftAutoLogin', 'true');
    }
    console.log(localStorage.getItem('authToken'));
    const headers = {
      'Authorization': token ? `Bearer ${token}` : '', // Include token if available
    };
    try {
      const response = await axios.get(Api.API_BASE_URL + 'dologout', { headers });


      localStorage.clear();
        sessionStorage.clear(); // Ensure session storage is cleared
        
        // Logout from Microsoft Account if active
        // This prevents the immediate auto-login loop
        instance.logoutRedirect({
          postLogoutRedirectUri: "/",
        }).catch(e => {
            console.error(e);
            window.location.href = '/'; 
        });


      } catch (error) {
        localStorage.clear();
        sessionStorage.clear();
         // Logout from Microsoft Account if active
         instance.logoutRedirect({
            postLogoutRedirectUri: "/",
          }).catch(e => {
              console.error(e);
              window.location.href = '/'; 
          });
      }
    };

  return (
    <>
      <nav>
        <div className="navbar">

          <div></div>
          {/* <div>
            <span className="main-title-font">
              {/* {organizationName.toUpperCase()} {currentPageName != '' ? ('/') : ('')} {currentPageName.toUpperCase()} */}
              {/* {(organizationName ? organizationName.toUpperCase() : 'DEFAULT_ORG_NAME')}
              {currentPageName !== '' ? ('/') : ('')}
              {(currentPageName ? currentPageName.toUpperCase() : '')}
            </span>
          </div> */}
          <div className="row d-flex justify-content-between align-items-center">
            <div className="">
              <Link to="/help">
                <MdHelpCenter size={35} title="Help & Support" />
              </Link>
            </div>
            {/* <div className='theme-platlet'>
              <ThemeMenu />
            </div> */}
            <div className="user-image" onClick={toggleDropdown}>

              <img src={getProfileImage()} alt="Profile" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} />

              <div className='nav-username'>

                <p className='text-sm font-bold'>
                  {userName}
                </p>
                <p className=''>
                  {role_name}
                </p>

              </div>
              {showDropdown && (
                <div className="dropdown-content">
                  <Link to="/profile" className='nav-name'>
                    <FaUserAlt /> Profile
                  </Link>

                  <Link onClick={handleLogout} className='nav-name' >
                    <FaPowerOff />  Logout
                  </Link>

                  {/* <div  className='theme-platlet'>
                    <ThemeMenu />
                  </div> */}

                </div>
              )}

            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
